(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-col-percentage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.collection-swiper', {
    slidesPerView: 1.2,               // mobile default
    spaceBetween: 10,
    centeredSlides: false,
    loop: true,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      768:  { slidesPerView: 2,   spaceBetween: 15 },
      1024: { slidesPerView: 4,   spaceBetween: 20 }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-tabs-slider"] && !Shopify.designMode) return;
  try {
    
/* -------- Tabs (unchanged) -------- */
document.querySelectorAll('.fcts').forEach(section => {
  const tabs   = section.querySelectorAll('.fcts__tab');
  const panels = section.querySelectorAll('.fcts__panel');

  tabs.forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = btn.dataset.index;
      tabs.forEach(t => t.classList.toggle('is-active', t.dataset.index === idx));
      panels.forEach(p => {
        const isActive = p.id.endsWith('-' + idx);
        p.toggleAttribute('hidden', !isActive);
        p.classList.toggle('is-active', isActive);

        /* ── init Swiper only when panel first becomes active ── */
        if (isActive && !p.swiperInit) {
          new Swiper(p.querySelector('.swiper'), {
            slidesPerView: 4,
            spaceBetween: 15,
            loop: true,
            autoplay: { delay: 3000, disableOnInteraction: false },
            pagination: { el: p.querySelector('.swiper-pagination'), clickable: true },
            breakpoints: {
              1024: { slidesPerView: 4 },
              768:  { slidesPerView: 3 },
              480:  { slidesPerView: 2 },
              0:    { slidesPerView: 1.2 }
            }
          });
          p.swiperInit = true;
        }
      });
    });
  });

  /* initialise the first visible panel immediately */
  const firstPanel = section.querySelector('.fcts__panel.is-active');
  if (firstPanel && !firstPanel.swiperInit) {
    new Swiper(firstPanel.querySelector('.swiper'), {
      slidesPerView: 4,
      spaceBetween: 15,
      loop: true,
      autoplay: { delay: 3000, disableOnInteraction: false },
      pagination: { el: firstPanel.querySelector('.swiper-pagination'), clickable: true },
      breakpoints: {
        1024: { slidesPerView: 4 },
        768:  { slidesPerView: 3 },
        480:  { slidesPerView: 2 },
        0:    { slidesPerView: 1.2 }
      }
    });
    firstPanel.swiperInit = true;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.load-more__btn');
  if (!btn) return;

  const wrapper = btn.closest('.load-more-wrapper');
  const nextLink = wrapper.querySelector('.load-more__link');
  if (!nextLink) return;

  // visual feedback
  btn.disabled = true;
  btn.textContent = 'Loading…';

  try {
    const res = await fetch(nextLink.href);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    /* 1) pull next page's product <li> elements */
    const nextItems = doc.querySelectorAll('#product-grid li');

    /* 2) append them to the current grid */
    const grid = document.querySelector('#product-grid');
    nextItems.forEach((item) => grid.appendChild(item));

    /* 3) replace the next URL; if none left, remove the button */
    const newNext = doc.querySelector('.load-more__link');
    if (newNext) {
      nextLink.href = newNext.href;
      btn.disabled = false;
      btn.textContent = "Load more";
    } else {
      wrapper.remove(); // no more pages
    }
  } catch (err) {
    console.error(err);
    btn.textContent = 'Error';
  }
});

  } catch(e) { console.error(e); }
})();
})();
